export default __webpack_public_path__ + "static/media/step5LightMode.b436cd15.svg";